import { useNavigate } from "react-router-dom";

const useWepapp = () => {

    const nav = useNavigate()

    function goToMenu(menu) {
        nav("/webapp/" + menu)
    }

    return {
        goToMenu
    }
}
export default useWepapp;